import axios from "axios";
import {
  FETCH_SF_CATEGORIES_REQUEST,
  FETCH_SF_CATEGORIES_SUCCESS,
  FETCH_SF_CATEGORIES_FAILURE
} from "Constants/redux";
import { ROOT_URL } from "Api";

export function fetchSfCategories(query = "") {
  return (dispatch, getState) => {
    const { location } = getState().locations;
    dispatch({ type: FETCH_SF_CATEGORIES_REQUEST });
    axios
      .get(
        `${ROOT_URL}/portal/inventories/sf_categories?location_id=${location.id}&query=${query}`
      )
      .then(response => {
        return dispatch({
          response,
          type: FETCH_SF_CATEGORIES_SUCCESS
        });
      })
      .catch(error => {
        console.log(error);
        dispatch({
          error,
          type: FETCH_SF_CATEGORIES_FAILURE
        });
      });
  };
}
